import { AUTO_PATH, AUTHORIZE_PATH } from '../constants/paths';
import viewTypes from '../constants/auth/viewTypes';
import { hasPairAuthFlowParam } from './auth/pairAuthFlowHelpers';

/**
 * @param query object
 * @param pathname string i.e. /authorize/
 * @param viewType string i.e. si, su, etc.
 * @returns boolean - true === should hide header
 */
export default function hideHeaderHelper(query, pathname, viewType) {
  const inPairAuthFlow = hasPairAuthFlowParam(query);
  const isSignInSignUpView = [viewTypes.signIn, viewTypes.signUp].includes(
    viewType,
  );

  return (
    inPairAuthFlow ||
    pathname === AUTO_PATH ||
    (pathname === AUTHORIZE_PATH && isSignInSignUpView)
  );
}
